export default __webpack_public_path__ + "static/media/SH.c53486e8.svg";